<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="500">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Evento do Calendário
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" @submit.prevent="">
            <sca-required-fields></sca-required-fields>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12" class="mb-0">
                <v-text-field
                  v-model="content.nome"
                  label="Evento do Calendário*"
                  outlined
                  dense
                  counter="100"
                  maxlength="100"
                  :rules="[(v) => $required(v), (v) => $max(v, 100),]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex mt-0">
              <v-col cols="3">
                <span class="text-body-1 mr-2 grey--text text--darken-1">Cor*</span>
              </v-col>
              <sca-color-picker v-model="content.corHexadecimal" :cols="2"></sca-color-picker>
            </v-row>
            <v-row class="d-flex align-center mt-0">
              <v-col cols="3">
                <span class="text-body-1 mr-2 grey--text text--darken-1">Dia Letivo*</span>
              </v-col>
              <v-switch v-model="content.diaLetivo"></v-switch>
            </v-row>
          </v-form>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { EventoCalendario } from '~/commons/classes/evento-calendario';
import EventoCalendarioService from '~/services/evento-calendario.service';

export default {
  props: new DialogProps(EventoCalendario),
  mixins: [EventoCalendarioService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o evento?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const eventoCalendario = new EventoCalendario(this.content).format();
          return this.edit
            ? this.$editarEventoCalendario(eventoCalendario, eventoCalendario.id)
            : this.$cadastrarEventoCalendario(eventoCalendario);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    remover(palavraChave) {
      this.content.palavrasChave.splice(
        this.content.palavrasChave.indexOf(palavraChave),
        1
      );
    }
  },
};
</script>